import React from 'react';
import {DistributionMap} from '../../../../../general';
import {useProductAttributes} from '../../../state';
import {MapSkeleton} from '../Skeleton/MapSkeleton';

interface SmallMapProps {
    hideOnLarge?: boolean;
}

export const SmallMap = ({hideOnLarge}: SmallMapProps) => {
    const {customAttributes, agentsConfiguration, agentsLoading} = useProductAttributes() || {};
    
    if (!customAttributes) {
        return null;
    }

    const f_tip_produs_attribute = customAttributes?.find(
        attribute => attribute.attribute_code === 'f_tip_produs'
    )?.value;

    if (f_tip_produs_attribute === 'Utilaje') {
        if (agentsLoading) {
            return (
                <div className={`${hideOnLarge ? 'lg:hidden' : ''} mt-6`}>
                    <MapSkeleton />
                </div>
            );
        }
        
        return (
            <div className={`flex items-center justify-center ${hideOnLarge ? 'lg:hidden' : ''} mt-6`}>
                <DistributionMap agentsConfiguration={agentsConfiguration} />
            </div>
        );
    }
    return null;
}

